import { mapState } from 'vuex';

export default {
  name: 'EditMemberIndex',
  data(){
    return {
      //- 目前進度
      step: 2,
      //- 身份別
      role: null,
      //- 真實姓名
      realUserName: null,
      //- 選擇的銀行別
      selectedBank: null,
      //- 分行的代碼或名稱
      bank_branch: null,
      //- 是否有推薦人
      referrer: null,
      //- 推薦人
      referrer_name: null,
      //- 是否同意
      agree: false,
      // 選擇的處
      selectedOffice: null,
      //- 假的部門
      departmentList: [
        { id: 0, name: '銀保暨多元通路處' },
        { id: 1, name: '銀一銀管部' },
        { id: 2, name: '銀二銀管部' },
        { id: 3, name: '營運發展部' },
        { id: 4, name: '⾏銷暨訓練部' },
        { id: 5, name: '⾏政部' },
      ],
      //- 選擇的部門
      selectedDepartment: null,
      //- 部門的科別或區域別
      departmentBranchList: [
        { id: 0, name: '科別一' },
        { id: 1, name: '科別二' },
        { id: 2, name: '科別三' },
        { id: 3, name: '區域別一' },
        { id: 4, name: '區域別二' },
        { id: 5, name: '區域別三' },
      ],
      //- 選擇的部門的科別或區域別
      selectedDepartmentBranch: null,
    }
  },
  mounted() {
    const vm = this;
    vm.$store.dispatch('edit_member/checkApply')
      .then(() => {
        vm.initPage();
      })
      .catch((error) => {
        if (error.data.message.includes('申請資料審核中')) {
          vm.$Swal.fire({
            icon: 'error',
            title: "操作失敗",
            html: error.data.message,
            confirmButtonText: '確認',
          })
            .then(() => {
              vm.$router.push({
                name: 'edit_member_pending'
              })
            })
        } else {
          vm.initPage();
        }
      })
  },
  methods:{
    initPage() {
      const vm = this;
      vm.$store.dispatch('sign_up/getSliverBank');
      vm.$store.dispatch('edit_member/getMemberInfo')
        .then(() => {
          vm.role = 'banker';
          vm.$store.dispatch('sign_up/getDiamondBank')
            .then(() => {
              vm.diamondBankList.forEach((bank) => {
                if (bank.name === vm.memberInfo.bank_name) {
                  vm.selectedBank = bank;
                  bank.branches.forEach((branch) => {
                    if (branch.name === vm.memberInfo.branch_name) {
                      vm.bank_branch = branch;
                    }
                  })
                }
              })
              vm.$Swal.close;
            })
        })
    },
    //- 選擇身份別
    selectRoleHandler: function(role){
      let vm = this;
      vm.role = role;
      vm.step = 2;
    },
    //- 選擇銀行
    selectHandler: function(type, data) {
      let vm = this;
      //- 判斷選擇什麼
      switch (type) {
        //- 銀行
        case 'bank':
          vm.selectedBank = data;
          //- 清空分行資料
          vm.bank_branch = null;
          break;
        //- 部門
        case 'office':
          vm.selectedOffice = data;
          vm.selectedDepartment = null;
          vm.selectedDepartmentBranch = null;
          break;
        case 'department':
          vm.selectedDepartment = data;
          //- 清空科別或區域別資料
          vm.selectedDepartmentBranch = null;
          break;
        //- 部門的科別或區域別
        case 'departmentBranch':
          vm.selectedDepartmentBranch = data;
          break;
        default:
          break;
      }
    },
    //- 選擇分行
    selectdiamondBankBranchHandler: function (value, id) {
      // console.log(value, id);
    },
    //- 送出
    async submitHandler() {
      let vm = this;
      let result;
      if(vm.role === 'banker') {
        result = await vm.checkBankerHandler();
      } else if (vm.role === 'fuboner') {
        result = await vm.checkFubonerHandler();
      } else if(vm.role === null || vm.role === '' || vm.role === undefined) {
        return;
      }

      if(result.pass === false) {
        vm.$Swal.fire({
          icon: 'error',
          title: '尚有未填寫完全欄位',
          text: result.errorText,
          confirmButtonText: '確認',
        });
        return;
      } else if (result.pass === true) {
        //- 送出資料
        vm.sendDataHandler();
        return;
      }
    },
    //- 檢查銀行人員
    checkBankerHandler: function() {
      let vm = this;
      let data = {
        pass: true,
        errorText: null,
      };
      return new Promise(resolve => {
        if(vm.selectedBank === null || vm.selectedBank === '' || vm.selectedBank === undefined) {
          data.pass = false;
          data.errorText = '銀行別尚未選擇';
          resolve(data);
          return;
        }
        if(vm.bank_branch === null || vm.bank_branch === '' || vm.bank_branch === undefined) {
          data.pass = false;
          data.errorText = '銀行代碼尚未選擇';
          resolve(data);
          return;
        }
        if(vm.agree === false || vm.agree === null) {
          data.pass = false;
          data.errorText = '同意事項尚未勾選';
          resolve(data);
          return;
        }
        resolve(data);
      })
    },
    //- 檢查富邦同仁
    checkFubonerHandler: function() {
      let vm = this;
      let data = {
        pass: true,
        errorText: null,
      };
      return new Promise(resolve => {
        if(vm.realUserName === null || vm.realUserName === '' || vm.realUserName === undefined) {
          data.pass = false;
          data.errorText = '真實姓名尚未填寫';
          resolve(data);
          return;
        }
        if(vm.selectedOffice === null || vm.selectedOffice === '' || vm.selectedOffice === undefined) {
          data.pass = false;
          data.errorText = '處尚未選擇';
          resolve(data);
          return;
        }
        if(vm.selectedDepartment === null || vm.selectedDepartment === '' || vm.selectedDepartment === undefined) {
          data.pass = false;
          data.errorText = '部門尚未選擇';
          resolve(data);
          return;
        }
        if(vm.selectedDepartmentBranch === null || vm.selectedDepartmentBranch === '' || vm.selectedDepartmentBranch === undefined) {
          data.pass = false;
          data.errorText = '科別或區別尚未選擇';
          resolve(data);
          return;
        }
        if(vm.agree === false || vm.agree === null) {
          data.pass = false;
          data.errorText = '同意事項尚未勾選';
          resolve(data);
          return;
        }
        resolve(data);
      })
    },
    sendDataHandler: function() {
      let vm = this;
      let data;
      //- 塞入要送出的資料
      if(vm.role === 'banker') {
        data = {
          line_uuid: vm.userInfo.userId,
          name: vm.realUserName,
          //- 1 銀保, 2 鑽保
          type: 2,
          branch_id: vm.bank_branch.branch_id,
          counselor: vm.referrer == 1 ? vm.referrer_name : null
        }
      } else if (vm.role === 'fuboner') {
        data = {
          line_uuid: vm.userInfo.userId,
          name: vm.realUserName,
          //- 1 銀保, 2 鑽保
          type: 1,
          department_id: vm.selectedDepartmentBranch.department_id,
        }
      }
      vm.$Swal.fire({
        title: '送出中, 請稍候',
        allowOutsideClick: false,
        onOpen: function onOpen() {
            vm.$Swal.showLoading();
        }
      });
      //- 打 API
      vm.$store.dispatch('edit_member/update', data)
        .then( res => {
          if (res.status == 200 && res.data.message === '申請成功') {
            vm.$store.commit('edit_member/setPendingMessage', '您的申請資料審核中，我們將儘快為您處理，請耐心等待!');
            vm.$router.push({
              name: 'edit_member_pending'
            });
          } else if (res.status == 200) {
            vm.$router.push({
              name: 'index'
            })
          }
        });
    },
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      diamondBankList: state => state.sign_up.diamondBankList, //- 鑽保
      sliverBankList: state => state.sign_up.sliverBankList,   //- 銀保
      applyRes: state => state.edit_member.applyRes, // 確認有沒有修改資格
      pendingMessage: state => state.edit_member.pendingMessage,
      memberInfo: state => state.edit_member.memberInfo,
    }),
  }
}
